import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Paper } from "@mui/material";
import { TableBody } from ".";
import { Pagination, SearchTable, TableHeader } from "../../TableTemplate";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import { applyFilter, getComparator } from "../../../Utils/table";
// import { fetchTeamLeader } from '../../../Store/PHPSlice/TeamLeader';
import { fetchTeamLeader } from "../../../Store/PHPSlice/TeamLeader/TeamLeader";
import { selectTeamLeaderReg } from "../../Selectors/Master/OutwardSelectors";


const TeamLeaderTable = () => {
  const dispatch = useDispatch();
  const getTeamLeader = useSelector(selectTeamLeaderReg);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("date");
  const [selected, setSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageRange, setPageRange] = useState([0, 10]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
      dispatch(fetchTeamLeader());
  }, [dispatch]);


  if (!getTeamLeader) return <h1>Loading...</h1>;

  const compData = Array.isArray(getTeamLeader.data)
    ? getTeamLeader.data.map((item, index) => ({
        id: item.ID,
        teamLeaderName: item.teamLeaderNm,
        date: item.dt, // ✅ ADD THIS
        serialNumber: index + 1,
      }))
    : [];


  const handleSort = (event, id) => {
    const isAsc = orderBy === id && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(id);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = compData.filter((item) =>
    item?.teamLeaderName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const dataFiltered = applyFilter({
    inputData: filteredData,
    comparator: getComparator(order, orderBy),
  });

  const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
  const displayedData = dataFiltered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

  const handleNextPageRange = () => {
    setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
  };

  const handlePreviousPageRange = () => {
    setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div style={{ margin: "2% 0%" }}>
        <h2>Team Leader Register</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper style={{ padding: "3vh" }}>
              <SearchTable
                handleItemsPerPageChange={handleItemsPerPageChange}
                searchTerm={searchTerm}
                handleSearchChange={handleSearchChange}
                totalItems={filteredData.length}
              />

              <TableContainer
                style={{ marginTop: "2%", border: "1px solid #ccc" }}
              >
                <Table>
                  <TableHeader
                    headCells={[
                      { id: "serialNumber", label: "Sr.No" },
                      { id: "date", label: "Date" },
                      { id: "teamLeaderName", label: "Team Leader Name" },
                      { id: "", label: "Edit" },
                      { id: "", label: "Delete" },
                    ]}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleSort}
                    numSelected={selected.length}
                    rowCount={compData.length}
                  />

                  <tbody>
                    {displayedData.map((row) => (
                      <TableBody
                        key={row.id}
                        id={row.id}
                        date={row.date}
                        teamLeaderName={row.teamLeaderName}
                        serialNumber={row.serialNumber}
                      />
                    ))}
                  </tbody>
                </Table>
              </TableContainer>

              <Pagination
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                handlePreviousPageRange={handlePreviousPageRange}
                visiblePageNumbers={visiblePageNumbers}
                pageNumber={pageNumbers}
                pageRange={pageRange}
                totalPages={totalPages}
                handleNextPageRange={handleNextPageRange}
              />
            </Paper>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default TeamLeaderTable;
